<template>
  <sidenav :orientation="orientation" :class="curClasses">
    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo bg-primary">
        <img src="../../public/vendor/img/logo .png" alt="" />
      </span>
      <router-link
        to="/dashboard"
        style="width: 100px; text-align: center; margin-left: 0.7rem !important"
        class="app-brand-text demo sidenav-text font-weight-normal ml-2"
      >
        <span v-if="show">{{ $t("m.header.navbar.APP_TITLE") }}</span>
      </router-link>
      <a
        href="javascript:void(0)"
        class="layout-sidenav-toggle sidenav-link text-large ml-auto"
        @click="toggleSidenav()"
      >
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div
      class="sidenav-inner"
      :class="{ 'py-1': orientation !== 'horizontal' }"
    >
      <template slot="link-text">{{ $t("m.aside.nav.SHOP") }}</template>
      <sidenav-menu
        v-if="power.shop_setting || power.shop_compartment"
        icon="ri-store-3-fill"
      >
        <template
          v-if="power.shop_setting || power.shop_compartment"
          slot="link-text"
        >
        {{ $t("m.aside.nav.SHOPS") }}
        </template>
        <sidenav-router-link
          v-if="power.shop_setting"
          to="/shop"
          :exact="true"
        >
          {{ $t("m.aside.nav.SHOP") }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="power.shop_compartment"
          to="/shopRoom"
          :exact="true"
        >
          {{ $t("m.aside.nav.ROOM") }}
        </sidenav-router-link>
      </sidenav-menu>
      <!-- 活动管理 -->
      <sidenav-menu
        v-if="power.activity_setting || power.activity_statistics"
        icon="ri-flag-fill"
      >
        <template
          v-if="power.activity_setting || power.activity_statistics"
          slot="link-text"
        >
          {{ $t("m.aside.nav.ACTIVITYS") }}
        </template>
        <sidenav-router-link
          v-if="power.activity_setting"
          to="/activitys"
          :exact="true"
        >
          {{ $t("m.aside.nav.ACTIVITYS_TUBE") }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="power.activity_statistics"
          to="/activityCount"
          :exact="true"
        >
          {{ $t("m.aside.nav.ACTIVITYS_SAT") }}
        </sidenav-router-link>
      </sidenav-menu>
      <!-- 优惠券 -->
      <sidenav-menu
        v-if="power.coupon_setting || power.coupon_used"
        icon="ri-coupon-fill"
      >
        <template slot="link-text">
          {{ $t("m.aside.nav.COUPON") }}
        </template>
        <sidenav-router-link
          v-if="power.coupon_setting"
          to="/coupon"
          :exact="true"
        >
          {{ $t("m.aside.nav.COUPON_MANAGE") }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="power.coupon_setting"
          to="/userCoupons"
          :exact="true"
        >
          {{ $t("m.aside.nav.COUPON_TABLE") }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="power.coupon_used"
          to="/merchantCoupon"
          :exact="true"
        >
          {{ $t("m.aside.nav.COUPON_USEAGE_RECORD") }}
        </sidenav-router-link>
      </sidenav-menu>

      <!-- 评论管理 -->
      <!-- <sidenav-menu v-if="power.app_commentSetting" icon="ion ion-md-chatboxes">
        <template v-if="power.app_commentSetting" slot="link-text">
          {{ $t("m.aside.nav.COMMENDS") }}
        </template>
        <sidenav-router-link
          v-if="power.app_commentSetting"
          icon="ion ion-md-chatboxes"
          to="/comment"
          :exact="true"
        >
          {{ $t("m.aside.nav.COMMEN") }}
        </sidenav-router-link>
      </sidenav-menu> -->
      <!-- 订单管理 -->
      <sidenav-menu
        v-if="power.order_list || power.order_ticket || power.order_statistics || power.user_goods"
        icon="ri-coupon-3-fill"
      >
        <template
          v-if="
            power.order_list || power.order_ticket || power.order_statistics
          "
          slot="link-text"
        >
          {{ $t("m.aside.nav.ORDER_TUBE") }}
        </template>
        <sidenav-router-link v-if="power.order_list" to="/order" :exact="true">
          {{ $t("m.aside.nav.ORDER") }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="power.order_ticket"
          to="/ticket"
          :exact="true"
        >
          {{ $t("m.aside.nav.TICKET") }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="power.user_goods"
          to="/userGoods"
          :exact="true"
        >
          {{ $t("m.aside.nav.USERGOODS_MANAGEMENT") }}
        </sidenav-router-link>
        <!-- <sidenav-router-link
          v-if="power.order_statistics"
          icon="ion ion-ios-stats"
          to="/orderStatistic"
          :exact="true"
        >
          {{ $t("m.aside.nav.ORDER_SAT") }}
        </sidenav-router-link> -->
      </sidenav-menu>
      <!-- 点数管理 -->
      <sidenav-menu
        v-if="power.user_pointTransaction"
        icon="ion icon-hand-coin-fill"
      >
        <template v-if="power.user_pointTransaction" slot="link-text">
          {{ $t("m.aside.nav.POINTS") }}
        </template>
        <sidenav-router-link
          v-if="power.user_pointTransaction"
          to="/points"
          :exact="true"
        >
          {{ $t("m.content.member.POINT_RECORD") }}
        </sidenav-router-link>
      </sidenav-menu>
      <!-- 角色管理 -->
      <sidenav-menu
        v-if="power.admin_roleSetting || power.admin_storeAdministrator"
        icon="ri-user-settings-fill"
      >
        <template
          v-if="power.admin_roleSetting || power.admin_storeAdministrator"
          slot="link-text"
        >
          {{ $t("m.aside.nav.ROLE") }}
        </template>
        <sidenav-router-link
          v-if="power.admin_roleSetting"
          to="/role"
          :exact="true"
        >
          {{ $t("m.aside.nav.ROLE") }}
        </sidenav-router-link>
        <sidenav-router-link
          v-if="power.admin_storeAdministrator"
          to="/shopRoles"
          :exact="true"
        >
          {{ $t("m.aside.nav.SHOPROLE") }}
        </sidenav-router-link>
      </sidenav-menu>
    </div>
  </sidenav>
</template>
<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider,
} from "@/vendor/libs/sidenav";

export default {
  name: "app-layout-sidenav",
  data: () => ({
    show: true,
    power: {},
  }),
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider,
  },

  props: {
    orientation: {
      type: String,
      default: "vertical",
    },
  },
  created() {
    this.power = JSON.parse(localStorage.getItem("role"));
    console.log(this.power);
  },

  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg;

      if (
        this.orientation === "horizontal" &&
        (bg.indexOf(" sidenav-dark") !== -1 ||
          bg.indexOf(" sidenav-light") !== -1)
      ) {
        bg = bg
          .replace(" sidenav-dark", "")
          .replace(" sidenav-light", "")
          .replace("-darker", "")
          .replace("-dark", "");
      }

      return (
        `bg-${bg} ` +
        (this.orientation !== "horizontal"
          ? "layout-sidenav"
          : "layout-sidenav-horizontal container-p-x flex-grow-0")
      );
    },
  },

  methods: {
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen(url) {
      return (
        this.$route.path.indexOf(url) === 0 && this.orientation !== "horizontal"
      );
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },
  },
};
</script>
<style>
@media (min-width: 992px) {
  .layout-collapsed:not(.layout-offcanvas):not(.layout-fixed-offcanvas)
    .layout-2
    .layout-sidenav {
    z-index: 10001 !important;
  }
  .layout-2 .layout-sidenav {
    z-index: 10001 !important;
  }
}
</style>
